const moment = require("moment");

export function dateGenericFormat(date) {
  if (date) {
    return moment(date).format("DD/MM/YYYY");
  } else {
    return date;
  }
}